import React, { useCallback } from 'react';
import { useCrossFlow } from '@atlassiansox/cross-flow-support';
import { IconButton } from '@atlaskit/button/new';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import { Box } from '@atlaskit/primitives';
import {
	useAnalyticsEvents,
	fireUIAnalytics,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { useBacklogSelector } from '../../../state/index.tsx';
import { getProjectName, projectIdSelector } from '../../../state/selectors/app/index.tsx';
import { useCoUseFlow } from '../co-use-flow/index.tsx';
import { CTA_SOURCE_CONTEXT, CTA_SOURCE_COMPONENT, type Flow } from '../constants.tsx';
import { onClickCTA } from '../on-click-cta/utils.tsx';

type BacklogButtonRefreshProps = {
	flow: Flow;
};

export const BacklogButtonRefresh = ({ flow }: BacklogButtonRefreshProps) => {
	const coUseEligible = flow === 'coUse';
	const crossFlowEligible = flow === 'crossFlow';
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const crossflow = useCrossFlow();

	const url = useCoUseFlow(coUseEligible);

	// Extract project name and project id
	const projectName = useBacklogSelector(getProjectName);
	const projectId = useBacklogSelector(projectIdSelector);

	const onPlanOnWhiteboard = useCallback(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'button',
			}),
			CTA_SOURCE_CONTEXT,
			{
				sourceComponent: CTA_SOURCE_COMPONENT,
				sourceContext: CTA_SOURCE_CONTEXT,
				experiment: 'backlogButtonRefresh',
			},
		);

		onClickCTA({
			createAnalyticsEvent,
			crossFlowEligible,
			crossflow,
			projectId,
			projectName,
			component: CTA_SOURCE_COMPONENT,
			context: CTA_SOURCE_CONTEXT,
			coUseEligible,
			url,
		});
	}, [
		crossFlowEligible,
		coUseEligible,
		projectId,
		projectName,
		crossflow,
		createAnalyticsEvent,
		url,
	]);

	return (
		<>
			<Box>
				<IconButton
					icon={WhiteboardIcon}
					onClick={onPlanOnWhiteboard}
					spacing="compact"
					label="whiteboards"
				/>
			</Box>
			<FireScreenAnalytics
				attributes={{ crossFlowEligible, coUseEligible, experiment: 'backlogButtonRefresh' }}
			/>
		</>
	);
};
